<template>
    <div data-app>
        <v-dialog v-model="dialog" persistent max-width="350">
            <v-card>
                <v-card-title class="headline">
                    Emin misiniz?
                </v-card-title>
                <v-card-text
                    >Silmek istediğiniz kayıt kalıcı olarak silinecektir. Bu
                    kaydı silmek istediğinize emin misiniz?</v-card-text
                >
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="text-danger" text @click="dialog = false">
                        Hayır
                    </v-btn>
                    <v-btn class="text-success" text @click="deleteUser()">
                        Evet
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <div>
            <KTCard v-bind:title="title_filters">
                <template v-slot:body>
                    <div class="row">
                        <div class="col-md-2"> 
                            
                            <select class="form-control" v-model="filter" @change="applyFilter(filter)">
                                <option v-for="filter in filters" :value="filter" :key="filter">{{ filter }}</option>
                            </select>
                        </div>
                        
                        <div class="col-md-2"> 
                            <b-button
                                v-if="hasPermission('passoligs.create')"
                                size="sm"
                                variant="secondary"
                                @click="clearFilters()"
                            >
                                Temizle
                            </b-button>
                        </div>

                        

                    </div>
                    
                </template>
            </KTCard>
            
        </div>  
        <div>
            
            <v-data-table
                :headers="headers"
                :items="paginateAllUsers"
                no-results-text="Herhangi bir sonuç bulunamadı..."
                disable-pagination
                :hide-default-footer="true"
                :server-items-length="meta_user.total"
                @update:options="sort"
                
            >
                <template v-slot:top>
                    <v-toolbar flat>
                        <v-toolbar-title>Kullanıcılar</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-col sm="1">
                            <b-form-select 
                                v-model="pageSize" 
                                :options="pageSizes" 
                                @change="handlePageSizeChange"
                            ></b-form-select>
                        </v-col>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        {{ meta_user.total }} kayıt
                        <v-divider class="mx-4" inset vertical></v-divider>
                        {{ meta_user.from }} - {{ meta_user.to }}
                        <v-divider class="mx-4" inset vertical></v-divider>
                        
                        <b-button
                            v-if="hasPermission('users.create')"
                            size="sm"
                            variant="primary"
                            @click="addUser()"
                        >
                            YENİ KAYIT
                        <i class="la la-plus"></i>
                        </b-button>

                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Araştır"
                            single-line
                            hide-details
                            @input="searchTable"
                        ></v-text-field>
                    </v-toolbar>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <div class="m-demo__preview m-demo__preview--btn">
                        <v-icon
                            class="la la-eye"
                            data-toggle="m-popover" title="Görüntüle"
                            @click="viewUser(item.id)"
                        >
                        </v-icon>
        
                        <v-icon v-if="hasPermission('users.update')"
                            class="la la-edit"
                            data-toggle="m-popover" title="Güncelle"
                            @click="editUser(item.id)"
                        >
                        </v-icon>

                        <v-icon v-if="hasPermission('users.delete')"
                            class="la la-trash"
                            data-toggle="m-popover" title="Sil"
                            @click="showDeleteDialog(item.id)"
                        >
                        </v-icon>
                        
                        <v-icon
                            v-if="hasPermission('users.print') && item.photo != 'media/users/blank.png' "
                            class="la la-print"
                            data-toggle="m-popover" 
                            title="Üye Kartı Yazdır"
                            @click="printCard(item.id)"
                        >
                        </v-icon>

                        
                    </div>    
                </template>

                <template v-slot:[`item.status`]="{item}">
                    <b-badge class="mr-1" :variant="getClass(item.status)">{{ item.status }}</b-badge>
                </template>

                <template v-slot:[`item.date_of_birth`]="{ item }">
                    <span>{{ item.date_of_birth | formatDate }}</span>
                </template>

                <template v-slot:[`item.membership_renews_at`]="{ item }">
                    <span>{{ item.membership_renews_at | formatDate }}</span>
                </template>

                <template v-slot:[`item.created_at`]="{ item }">
                    <span>{{ item.created_at | formatDateTime }}</span>
                </template>
                <template v-slot:[`item.updated_at`]="{ item }">
                    <span>{{ item.updated_at | formatDateTime }}</span>
                </template>
                
                
                <template v-slot:[`item.roles`]="{ item }">
                    <b-badge v-for="role in item.roles" class="mr-1" :key="role.id" variant="success">{{ role.name }}</b-badge>
                </template>
                


                <template v-slot:footer>
                    <v-toolbar flat>
                        <template>
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <b-pagination
                                        v-model="page"
                                        :total-rows="meta_user.total"
                                        :per-page="itemsPerPage"
                                        size="lg"
                                        @input="handlePageChange"
                                        align="right"
                                        first-number
                                        last-number
                                    ></b-pagination>
                                </v-col>
                            </v-row>
                        </template>
                    </v-toolbar>
                </template>
            
            </v-data-table>
        </div>
        
        <br />
        <div class="text-center">
            <b-spinner
                variant="primary"
                type="grow"
                label="Spinning"
                v-if="loading"
            ></b-spinner>
        </div>
      
    </div>
    
</template>

<script>

import { mapGetters } from 'vuex';
import { mapState } from 'vuex';
import { PAGINATE_ALL_USERS } from "@/core/services/store/users.module";
import { DELETE_USER } from "@/core/services/store/users.module";
import axios from "axios";
import KTCard from "@/view/content/Card.vue";

export default {
    name: "users-list",
    data() {
        return {
            title: "",
            title_filters: "Filtreler",
            search: "",
            dialog: false,
            itemToDelete: "",
            page: 1,
            itemsPerPage: 10,
            pageSize: 10,
            pageSizes: [10, 25, 50, 100],
            totalPages: 0,
            currentPage: 1,
            total: 0,
            from: 0, 
            to: 0,
            sortBy: 'updated_at',
            sortDesc: true,
            timer: null,
            row: false,
            headers: [
                { text: "İşlemler", value: "actions", sortable: false },
                { text: "ID", align: "start", value: "id" },
                { text: "İsim Soyisim", value: "name" },
                { text: "Doğum Tarihi", value: "date_of_birth" },
                { text: "E-mail", value: "email" },
                { text: "Kullanıcı Rolleri", value: "roles" },
                { text: "Üyelik Yenileme Tarihi", value: "membership_renews_at" },
                { text: "Statü", value: "status" },
                { text: "Ekleyen", value: "user_created_name[0].name" },
                { text: "Ekleme Tarihi", value: "created_at" },
                { text: "Güncelleyen", value: "user_updated_name[0].name" },
                { text: "Güncelleme Tarihi", value: "updated_at" }
            ],

            filters: [
                "Ödeme Yapıldı Onay Bekliyor",
                "Eski Üye Olarak Aktarıldı",
                "Yeni",
                "Aktif",
                "İhraç",
                "İstifa",
                "Vefat"
            ],
            filter: 0
        };
    },

    methods: {
        handlePageChange(value) {
            this.currentPage = value;
            this.paginate();
        },

        searchTable(value){
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.search = value;
                this.paginate();
            }, 500);
        },

        sort(options){
            this.sortBy = options.sortBy;
            this.sortDesc = options.sortDesc;
            this.paginate();
        },

        handlePageSizeChange(size) {
            this.pageSize = size;
            this.itemsPerPage = size;
            this.page = 1;
            this.paginate();
        },
        
        showDeleteDialog(id) {
            this.itemToDelete = id
            this.dialog = !this.dialog
        },

        addUser() {
            this.$router.push({
                name: "users-form",
                params: { formType: "add"}
            });
        },

        editUser(id) {
            this.$router.push({
                name: "users-form",
                params: { id: id, formType: "edit" }
            });
        },

        viewUser(id) {
            this.$router.push({
                name: "users-form",
                params: { id: id, formType: "view" }
            });
        },
        
        deleteUser() {
            this.dialog = false;
            
            var itemToDelete = this.itemToDelete;
            this.$store.dispatch(DELETE_USER, {
                    itemToDelete
                });
            this.paginate();
        },
        paginate() {
            var pageNumber = this.page;
            var itemsPerPage = this.itemsPerPage;
            var sortBy = this.sortBy;  
            var sortDesc = this.sortDesc; 
            var search = this.search;
            var x = 1;

            this.$store.dispatch(PAGINATE_ALL_USERS, {
                    itemsPerPage, 
                    pageNumber, 
                    sortBy, 
                    sortDesc, 
                    search,
                    x
                });
            },

        hasPermission(permission) {
            return this.currentUserMenu.permissions.some(function(el) {
                return el.name === permission;
            }); 
        },
        
        getClass(status) {
            if (status == "Ödeme Yapıldı Onay Bekliyor") return 'warning'
            if (status == "Eski Üye Olarak Aktarıldı") return 'warning'
            if (status == "Aktif") return 'primary'
            if (status == "İhraç") return 'danger'
            if (status == "İstifa") return 'warning'
            if (status == "Vefat") return 'secondary'
        },

        async printCard(id) {
            axios({
                url: `/user/print_card/${id}`,
                method: 'GET',
                responseType: 'arraybuffer',
            })
            .then((response) => {
                const blob = new Blob([response.data], {
                            type: 'application/octet-stream'
                        });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'user_card_'+id+'.pdf');
                document.body.appendChild(link);
                link.click();
                link.remove();
            });
            
        },

        applyFilter(filter) {
            this.search = filter;
            this.searchTable(filter);
        },
        
        clearFilters() {
            this.search = "";
            this.filter = "";
            this.searchTable(this.search);
        },

        },
    created(){
        this.$store.dispatch('getUserMenu');
        
        
        
    },

    components: {
        KTCard
    },
   
    computed: {
        
        ...mapGetters(["paginateAllUsers", "meta_user", "currentUserMenu"]),
        
        ...mapState({
            loading: state => state.users.loading,
        }),
        
    },

};
</script>
